import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import { WHITE, BLACK } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const StatisticItemContainer = styled.div`
  background: ${WHITE};
  border-radius: 6px;
  text-align: center;
  padding: 30px;
  min-height: 205px;
  transition: box-shadow 0.4s ease;

  &:hover {
    box-shadow: 0 30px 30px ${rgba(BLACK, 0.06)};
  }

  b {
    display: block;
    margin-top: 30px;
    margin-bottom: 8px;
  }

  p {
    font-weight: 400;
    line-height: 2rem;

    ${breakpoints.down('xs')} {
      max-width: 195px;
      margin-right: auto;
      margin-left: auto;
    }
  }
`;

export default StatisticItemContainer;
